import { render, staticRenderFns } from "./PeopleRelated.vue?vue&type=template&id=c69c4ea2&scoped=true&"
import script from "./PeopleRelated.vue?vue&type=script&lang=js&"
export * from "./PeopleRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69c4ea2",
  null
  
)

export default component.exports